export default "__VITE_ASSET__hxOn728s__"